'use strict';

// modified netteForms from live-form-validation
//live-form-validation.js - last updated commit:
// https://github.com/contributte/live-form-validation/pull/57/files#

/**
 * NetteForms - simple form validation.
 *
 * This file is part of the Nette Framework (https://nette.org)
 * Copyright (c) 2004 David Grudl (https://davidgrudl.com)
 */

(function netteForms(global, factory) {
    if (!global.JSON) {
        return;
    }

    let init = !global.Nette || !global.Nette.noInit;
    global.Nette = factory(global);
    if (init) {
        global.Nette.initOnLoad();
    }
}(typeof window !== 'undefined' ? window : this, function netteDefine(window) {
    const Nette = {};
    const preventFiltering = {};
    let formToggles = {};
    window.Nette = Nette;
    Nette.version = '3.0';

    /**
     * Function to execute when the DOM is fully loaded.
     * @private
     */
    Nette.onDocumentReady = function(callback) {
        if (document.readyState !== 'loading') {
            callback.call(this);
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    };

    /**
     * Returns the value of form element.
     */
    Nette.getValue = function getValue(elem) {
        let i;
        if (!elem) {
            return null;
        } else if (!elem.tagName) { // RadioNodeList, HTMLCollection, array
            return elem[0] ? Nette.getValue(elem[0]) : null;
        } else if (elem.type === 'radio') {
            let elements = elem.form.elements; // prevents problem with name 'item' or 'namedItem'
            for (i = 0; i < elements.length; i++) {
                if (elements[i].name === elem.name && $(elements[i]).iCheck('update')[0].checked) {
                    return elements[i].value;
                }
            }
            return null;
        } else if (elem.type === 'file') {
            return elem.files || elem.value;
        } else if (elem.tagName.toLowerCase() === 'select') {
            let index = elem.selectedIndex;
            let options = elem.options;
            let values = [];

            if (elem.type === 'select-one') {
                return index < 0 ? null : options[index].value;
            }

            for (i = 0; i < options.length; i++) {
                if (options[i].selected) {
                    values.push(options[i].value);
                }
            }
            return values;
        } else if (elem.name && elem.name.match(/\[\]$/)) { // multiple elements []
            let elements = elem.form.elements[elem.name].tagName ? [elem] : elem.form.elements[elem.name];
            let values = [];
            for (i = 0; i < elements.length; i++) {
                // LiveForm: original netteForms.js code
                /*if (elements[i].type !== 'checkbox' || elements[i].checked) {
                    values.push(elements[i].value);
                }*/
                // LiveForm: addition
                let value = elements[i].value;
                if (elements[i].type === 'checkbox' && $(elements[i]).iCheck('update')[0].checked) {
                    values.push(value);
                } else if (elements[i].type !== 'checkbox' && value !== '') {
                    values.push(value);
                }
            }
            return values;
        } else if (elem.type === 'checkbox') {
            return $(elem).iCheck('update')[0].checked;
        } else if (elem.tagName.toLowerCase() === 'textarea') {
            return elem.value.replace('\r', '');
        } else {
            let element = $(elem)[0];
            if ($(element).attr('parent') !== undefined) { // addEntities form
                let entitiesClosestForm = $(element).closest('form').attr('id');

                let parentId = $(element).attr('parent');
                let parentInput = $(`form#${entitiesClosestForm} input#${parentId}`)[0];
                return $(parentInput).val();
            }
            return elem.value.replace('\r', '').replace(/^\s+|\s+$/g, '');
        }
    };

    /**
     * Returns the effective value of form element.
     */
    Nette.getEffectiveValue = function getValue(elem, filter) {
        let val = Nette.getValue(elem);
        if (elem.getAttribute) {
            if (val === elem.getAttribute('data-nette-empty-value')) {
                val = '';
            }
        }
        if (filter && preventFiltering[elem.name] === undefined) {
            preventFiltering[elem.name] = true;
            let ref = {value: val};
            Nette.validateControl(elem, null, true, ref);
            val = ref.value;
            delete preventFiltering[elem.name];
        }
        return val;
    };

    /**
     * Validates form element against given rules.
     */
    Nette.validateControl = function validateControl(elem, rules, onlyCheck, value, emptyOptional) {
        // LiveForm: addition
        // Fix for CheckboxList - validation rules are present always only on first input
        if (elem.name && elem.name.match(/\[\]$/) && elem.type.toLowerCase() === 'checkbox') {
            elem = elem.form.elements[elem.name].tagName ? elem : elem.form.elements[elem.name][0];
        }

        elem = elem.tagName ? elem : elem[0]; // RadioNodeList
        rules = rules || JSON.parse(elem.getAttribute('data-nette-rules') || '[]');

        if (rules.length === 0) {
            let closestLi = elem.closest('li');
            if (closestLi) {
                let subElement = closestLi.closest('.select2');
                let multiSelectElement = $(subElement).siblings('select')[0];
                rules = JSON.parse(multiSelectElement.getAttribute('data-nette-rules') || '[]');
                elem = multiSelectElement;
            }
        }
        value = value === undefined ? {value: Nette.getEffectiveValue(elem)} : value;
        emptyOptional = emptyOptional || !Nette.validateRule(elem, ':filled', null, value);

        for (let id = 0, len = rules.length; id < len; id++) {
            let rule = rules[id];
            let op = rule.op.match(/(~)?([^?]+)/);
            let curElem = rule.control ? elem.form.elements.namedItem(rule.control) : elem;

            rule.neg = op[1];
            rule.op = op[2];
            rule.condition = !!rule.rules;

            if (!curElem) {
                continue;
            } else if (emptyOptional && !rule.condition && rule.op !== ':filled') {
                continue;
            }
            curElem = curElem.tagName ? curElem : curElem[0]; // RadioNodeList
            let success = Nette.validateRule(curElem, rule.op, rule.arg, elem === curElem ? value : undefined);

            if (success === null) {
                continue;
            } else if (rule.neg) {
                success = !success;
            }

            if (rule.condition && success) {
                if (!Nette.validateControl(elem, rule.rules, onlyCheck, value, rule.op === ':blank' ? false : emptyOptional)) {
                    return false;
                }
            } else if (!rule.condition && !success) {
                if (Nette.isDisabled(curElem)) {
                    continue;
                }
                if (!onlyCheck) {
                    let arr = Array.isArray(rule.arg) ? rule.arg : [rule.arg],
                        message = rule.msg.replace(/%(value|\d+)/g, function(foo, m) {
                            return Nette.getValue(m === 'value' ? curElem : elem.form.elements.namedItem(arr[m].control));
                        });
                    Nette.addError(curElem, message);
                }
                return false;
            }
        }

        if (elem.type === 'number' && !elem.validity.valid) {
            if (!onlyCheck) {
                Nette.addError(elem, 'Please enter a valid value.');
            }
            return false;
        }

        // window.LiveForm: addition
        if (!onlyCheck) {
            window.LiveForm.removeError(elem);
        }

        return true;
    };

    /**
     * Validates whole form.
     */
    Nette.validateForm = function validateForm(sender) {
        let form = sender.form || sender;
        let scope = false;

        window.actualForm = form;
        // window.LiveForm: addition
        window.LiveForm.setFormProperty(form, 'hasError', false);

        // window.LiveForm: original netteForms.js code
        // Nette.formErrors = [];

        if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
            let scopeArr = JSON.parse(form['nette-submittedBy'].getAttribute('data-nette-validation-scope') || '[]');
            if (scopeArr.length) {
                scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
            } else {
                // LiveForm: original netteForms.js code
                // Nette.showFormErrors(form, []);
                return true;
            }
        }

        let radios = {};
        let i;
        let elem;
        // window.LiveForm: addition
        let success = true;

        for (i = 0; i < form.elements.length; i++) {
            elem = form.elements[i];

            if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
                continue;
            } else if (elem.type === 'radio') {
                if (radios[elem.name]) {
                    continue;
                }
                radios[elem.name] = true;
            }

            if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
                continue;
            }

            // window.LiveForm: addition
            success = Nette.validateControl(elem) && success;
            if (!success && !window.LiveForm.options.showAllErrors) {
                break;
            }

            if (!success) {
                try {
                    let pane = $('.has-error').first().closest('.tab-pane');
                    let id = '#' + pane.attr('id');
                    $('a[href="'+id+'"]').tab('show')
                } catch(e) { console.log('No tab with error found') }
            }
        }

        // window.LiveForm: change
        return success;
    };

    /**
     * Check if input is disabled.
     */
    Nette.isDisabled = function isDisabled(elem) {
        if (elem.type === 'radio') {
            for (let i = 0, elements = elem.form.elements; i < elements.length; i++) {
                if (elements[i].name === elem.name && !elements[i].disabled) {
                    return false;
                }
            }
            return true;
        }
        return elem.disabled;
    };

    /**
     * Display error message.
     */
    Nette.addError = function addError(elem, message) {
        // window.LiveForm: addition
        let noLiveValidation = window.LiveForm.hasClass(elem, window.LiveForm.options.disableLiveValidationClass);
        // User explicitly disabled live-validation so we want to show simple alerts
        if (noLiveValidation) {
            // notify errors for elements with disabled live validation (but only errors and not during onLoadValidation)
            if (message
                && !window.LiveForm.getFormProperty(elem.form, 'hasError')
                && !window.LiveForm.getFormProperty(elem.form, 'onLoadValidation')) {
                alert(message);
            }
        }
        if (elem.focus && !window.LiveForm.getFormProperty(elem.form, 'hasError')) {
            if (!window.LiveForm.focusing) {
                window.LiveForm.focusing = true;
                elem.focus();
                setTimeout(() => {
                    window.LiveForm.focusing = false;

                    // Scroll by defined offset (if enabled)
                    // NOTE: We use it with setTimetout because IE9 doesn't always catch instant scrollTo request
                    let focusOffsetY = window.LiveForm.options.focusScreenOffsetY;
                    if (focusOffsetY !== false && elem.getBoundingClientRect().top < focusOffsetY) {
                        window.scrollBy(0, elem.getBoundingClientRect().top - focusOffsetY);
                    }
                }, 10);
            }
        }
        if (!noLiveValidation) {
            window.LiveForm.addError(elem, message);
        }
    };

    /**
     * Validates single rule.
     */
    Nette.validateRule = function validateRule(elem, op, arg, value) {
        value = value === undefined ? { value: Nette.getEffectiveValue(elem) } : value;

        if (op.charAt(0) === ':') {
            op = op.substr(1);
        }
        op = op.replace('::', '_');
        op = op.replace(/\\/g, '');

        let arr = Array.isArray(arg) ? arg.slice(0) : [arg];
        for (let i = 0, len = arr.length; i < len; i++) {
            if (arr[i] && arr[i].control) {
                let control = elem.form.elements.namedItem(arr[i].control);
                arr[i] = control === elem ? value.value : Nette.getEffectiveValue(control, true);
            }
        }
        return Nette.validators[op]
            ? Nette.validators[op](elem, Array.isArray(arg) ? arr : arr[0], value.value, value)
            : null;
    };

    Nette.validators = {
        filled(elem, arg, val) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return true;
            }
            return val !== '' && val !== false && val !== null
                && (!Array.isArray(val) || !!val.length)
                && (!window.FileList || !(val instanceof window.FileList) || val.length);
        },

        blank(elem, arg, val) {
            return !Nette.validators.filled(elem, arg, val);
        },

        valid(elem) {
            return Nette.validateControl(elem, null, true);
        },

        equal(elem, arg, val) {
            if (arg === undefined) {
                return null;
            }

            function toString(val)
            {
                if (typeof val === 'number' || typeof val === 'string') {
                    return `${val}`;
                }
                return val === true ? '1' : '';
            }

            val = Array.isArray(val) ? val : [val];
            arg = Array.isArray(arg) ? arg : [arg];
            loop:
                for (let i1 = 0, len1 = val.length; i1 < len1; i1++) {
                    for (let i2 = 0, len2 = arg.length; i2 < len2; i2++) {
                        if (toString(val[i1]) === toString(arg[i2])) {
                            continue loop;
                        }
                    }
                    return false;
                }
            return true;
        },

        notEqual(elem, arg, val) {
            return arg === undefined ? null : !Nette.validators.equal(elem, arg, val);
        },

        minLength(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.tooShort) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return val.length >= arg;
        },

        maxLength(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.tooLong) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return val.length <= arg;
        },

        length(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.tooShort || elem.validity.tooLong) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            arg = Array.isArray(arg) ? arg : [arg, arg];
            return (arg[0] === null || val.length >= arg[0]) && (arg[1] === null || val.length <= arg[1]);
        },

        email(elem, arg, val) {
            // eslint-disable-next-line max-len
            return (/^("([ !#-[\]-~]|\\[ -~])+"|[-a-z0-9!#$%&'*+/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?$/i).test(val);
        },

        url(elem, arg, val, value) {
            if (!(/^[a-z\d+.-]+:/).test(val)) {
                val = `http://${val}`;
            }
            // eslint-disable-next-line max-len
            if ((/^https?:\/\/((([-_0-9a-z\u00C0-\u02FF\u0370-\u1EFF]+\.)*[0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)?[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\[[0-9a-f:]{3,39}\])(:\d{1,5})?(\/\S*)?$/i).test(val)) {
                value.value = val;
                return true;
            }
            return false;
        },

        regexp(elem, arg, val) {
            let parts = typeof arg === 'string' ? arg.match(/^\/(.*)\/([imu]*)$/) : false;
            try {
                return parts && (new RegExp(parts[1], parts[2].replace('u', ''))).test(val);
            } catch (e) {
            }
        },

        pattern(elem, arg, val, value, caseInsensitive) {
            if (typeof arg !== 'string') {
                return null;
            }

            try {
                let regExp;
                try {
                    regExp = new RegExp('^(?:' + arg + ')$', caseInsensitive ? 'ui' : 'u');
                } catch (e) {
                    regExp = new RegExp('^(?:' + arg + ')$', caseInsensitive ? 'i' : '');
                }
                if (window.FileList && val instanceof FileList) {
                    for (let i = 0; i < val.length; i++) {
                        if (!regExp.test(val[i].name)) {
                            return false;
                        }
                    }
                    return true;
                }
                return regExp.test(val);
            } catch (e) {} // eslint-disable-line no-empty
        },

        patternCaseInsensitive(elem, arg, val) {
            return Nette.validators.pattern(elem, arg, val, null, true);
        },

        numeric(elem, arg, val) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return false;
            }
            return (/^[0-9]+$/).test(val);
        },

        integer(elem, arg, val) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return false;
            }
            return (/^(-?[0-9]+)?$/).test(val);
        },

        float(elem, arg, val, value) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return false;
            }
            val = val.replace(/ +/g, '').replace(/,/g, '.');
            if ((/^-?[0-9]*\.?[0-9]+$/).test(val)) {
                value.value = val;
                return true;
            }
            return false;
        },

        min(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.rangeUnderflow) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return arg === null || parseFloat(val) >= arg;
        },

        max(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.rangeOverflow) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return arg === null || parseFloat(val) <= arg;
        },

        range(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.rangeUnderflow || elem.validity.rangeOverflow) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }

            return Array.isArray(arg) ?
                ((arg[0] === null || parseFloat(val) >= arg[0]) && (arg[1] === null || parseFloat(val) <= arg[1])) : null;
        },

        submitted(elem) {
            return elem.form['nette-submittedBy'] === elem;
        },

        fileSize(elem, arg, val) {
            if (window.FileList) {
                for (let i = 0; i < val.length; i++) {
                    if (val[i].size > arg) {
                        return false;
                    }
                }
            }
            return true;
        },

        image(elem, arg, val) {
            if (window.FileList && val instanceof window.FileList) {
                for (let i = 0; i < val.length; i++) {
                    let type = val[i].type;
                    if (type && type !== 'image/gif' && type !== 'image/png' && type !== 'image/jpeg') {
                        return false;
                    }
                }
            }
            return true;
        },
        static(elem, arg) {
            return arg;
        }
    };

    /**
     * Process all toggles in form.
     */
    Nette.toggleForm = function toggleForm(form, elem) {
        let i;
        formToggles = {};
        for (i = 0; i < form.elements.length; i++) {
            if (form.elements[i].tagName.toLowerCase() in {
                input: 1, select: 1, textarea: 1, button: 1,
            }) {
                Nette.toggleControl(form.elements[i], null, null, !elem);
            }
        }
        for (i in formToggles) {
            Nette.toggle(i, formToggles[i], elem);
        }
    };

    /**
     * Process toggles on form element.
     */
    Nette.toggleControl = function toggleControl(elem, rules, success, firsttime, value) {
        rules = rules || JSON.parse(elem.getAttribute('data-nette-rules') || '[]');
        value = value === undefined ? { value: Nette.getEffectiveValue(elem) } : value;

        let has = false;
        let handled = [];
        let curSuccess;
        let handler = () => {
            Nette.toggleForm(elem.form, elem);
        };

        for (let id = 0, len = rules.length; id < len; id++) {
            let rule = rules[id];

            let op = rule.op.match(/(~)?([^?]+)/);
            let curElem = rule.control ? elem.form.elements.namedItem(rule.control) : elem;
            if (!curElem) {
                continue;
            }

            curSuccess = success;
            if (success !== false) {
                rule.neg = op[1];
                rule.op = op[2];
                curSuccess = Nette.validateRule(curElem, rule.op, rule.arg, elem === curElem ? value : undefined);
                if (curSuccess === null) {
                    continue;
                } else if (rule.neg) {
                    curSuccess = !curSuccess;
                }
                if (!rule.rules) {
                    success = curSuccess;
                }
            }

            if ((rule.rules && Nette.toggleControl(elem, rule.rules, curSuccess, firsttime, value)) || rule.toggle) {
                has = true;
                if (firsttime) {
                    let name = curElem.tagName ? curElem.name : curElem[0].name;
                    let els = curElem.tagName ? curElem.form.elements : curElem;

                    for (let i = 0; i < els.length; i++) {
                        if (els[i].name === name && handled.indexOf(els[i]) < 0) {
                            els[i].addEventListener('change', handler);
                            handled.push(els[i]);
                        }
                    }
                }
                for (let id2 in rule.toggle || []) {
                    if (Object.prototype.hasOwnProperty.call(rule.toggle, id2)) {
                        formToggles[id2] = formToggles[id2] || (rule.toggle[id2] ? curSuccess : !curSuccess);
                    }
                }
            }
        }
        return has;
    };

    /**
     * Displays or hides HTML element.
     */
    Nette.toggle = function toogles(selector, visible, srcElement) { // eslint-disable-line no-unused-vars
        if (/^\w[\w.:-]*$/.test(selector)) { // id
            selector = '#' + selector;
        }
        /*
        var elems = document.querySelectorAll(selector);
        for (var i = 0; i < elems.length; i++) {
            elems[i].hidden = !visible;
        }*/
        let parts = selector.split('|');

        let action = 'HIDE';

        if (parts.length > 1) {
            selector = parts[0];
            action = parts[1];
        }

        switch (action) {
        case 'HIDE':
            toggleHide(selector, visible);
            break;
        case 'SLIDE':
            toggleSlide(selector, visible);
            break;
        case 'READ_ONLY':
            toggleReadOnly(selector, visible);
            break;
        case 'REQUIRE':
            toggleRequire(selector, visible);
            break;
        case 'VALUE':
            if (visible) {
                toggleValue(selector, parts[2]);
            }
            break;
        case 'ALERT':
            if (visible) {
                alert(parts[2]);
            }
            break;
        default:
            // console.debug([$(selector), visible, action, parts]);
            break;
        }
    };

    function toggleHide(selector, visible)
    {
        if (visible) {
            $(selector).closest('.form-group').hide();
        } else {
            $(selector).closest('.form-group').show();
        }
    }

    function toggleSlide(selector, visible)
    {
        if (visible) {
            $(selector).closest('.form-group').slideUp();
        } else {
            $(selector).closest('.form-group').slideDown();
        }
    }

    function toggleReadOnly(selector, visible)
    {
        let items = $(selector).closest('.form-group');
        if (visible) {
            items.find('.timepicker').each(function timepickerEach() {
                $(this).datepicker('option', 'disabled', true);
                $(this).removeClass('timepicker');
                $(this).addClass('readonly_timepicker');
            });
            items.find('.datepicker').each(function datepickerEach() {
                $(this).datepicker('option', 'disabled', true);
                $(this).removeClass('datepicker');
                $(this).addClass('readonly_datepicker');
            });
            items.find('.datetimepicker').each(function datetimePicker() {
                $(this).datepicker('option', 'disabled', true);
                $(this).removeClass('datetimepicker');
                $(this).addClass('readonly_datetimepicker');
            });
            items.find('input').each(function inputEach() {
                switch (this.type) {
                case 'text':
                case 'email':
                case 'number':
                case 'password':
                    $(this).removeAttr('disabled');
                    $(this).attr('readonly', 'readonly');
                    break;
                case 'button':
                case 'image':
                case 'file':
                    $(this).prop('disabled', true);
                    break;
                case 'radio':
                case 'checkbox':
                    $(this).prop('disabled', true);
                    $(this).parent().addClass('disabled');
                    break;
                default:
                    //                            console.debug(this);
                    break;
                }
            });
            items.find('div.input-group-addon').each(function inputGroupEach() {
                $(this).addClass('hide');
            });
            items.find('ul.dropdown-menu').each(function dropdownMenuEach() {
                $(this).addClass('hide');
            });
            items.find('textarea').each(function textareaEach() {
                $(this).prop('readonly', 'readonly');
            });
            items.find('select').each(function selectEach() {
                $(this).parent().find('select :not(option:selected)').each(function selectNotEach() {
                    $(this).attr('disabled', 'disabled');
                });
                $(this).parent().find('.select2-selection__arrow').each(function selectionArrowEach() {
                    $(this).addClass('readonly-select-button');
                });
                $(this).parent().find('.select2-selection__rendered').each(function selectionrenderedEach() {
                    $(this).addClass('readonly-select');
                });
            });
        } else {
            items.find('.readonly_timepicker').each(function readonlyTimpePickerEach() {
                $(this).datepicker('option', 'disabled', false);
                $(this).removeClass('readonly_timepicker');
                $(this).addClass('timepicker');
            });
            items.find('.readonly_datepicker').each(function readonlyDatePickerEach() {
                $(this).datepicker('option', 'disabled', false);
                $(this).removeClass('readonly_datepicker');
                $(this).addClass('datepicker');
            });
            items.find('.readonly_datetimepicker').each(function readonlyDateTimePickerEach() {
                $(this).datepicker('option', 'disabled', false);
                $(this).removeClass('readonly_datetimepicker');
                $(this).addClass('datetimepicker');
            });
            items.find('input').each(function inputTypeEch() {
                switch (this.type) {
                case 'text':
                case 'email':
                case 'number':
                case 'password':
                    $(this).removeAttr('readonly');
                    break;
                case 'button':
                case 'image':
                case 'file':
                    $(this).prop('disabled', false);
                    break;
                case 'radio':
                case 'checkbox':
                    $(this).prop('disabled', false);
                    $(this).parent().removeClass('disabled');
                    break;
                default:
                    // console.debug(this);
                    break;
                }
            });
            items.find('div.input-group-addon').each(function inputGroupAddonEach() {
                $(this).removeClass('hide');
            });
            items.find('ul.dropdown-menu').each(function dropDownMenuEach() {
                $(this).removeClass('hide');
            });
            items.find('textarea').each(function textAreaEach() {
                $(this).prop('readonly', '');
            });
            items.find('select').each(function selectEach() {
                $(this).parent().find('option').each(function parentOptionEach() {
                    $(this).removeAttr('disabled');
                });
                $(this).parent().find('.select2-selection__arrow').each(function selectArrowEach() {
                    $(this).removeClass('readonly-select-button');
                });
                $(this).parent().find('.select2-selection__rendered').each(function selectionRenderedEach() {
                    $(this).removeClass('readonly-select');
                });
            });
        }
    }

    function toggleRequire(selector, visible)
    {
        let items = $(selector).closest('.form-group');
        if (visible) {
            items.addClass('required');
            items.each(function itemEach() {
                $(this).children('label').children('span').remove();
                let label = $(this).children('label');
                label.html(`${label.html()}<span class="required"> *</span>`);
            });

            items.find('input, textarea, select').each(function itemsFindEach() {
                $(this).prop('required', true);
                $(this).attr('data-nette-rules', '[{"op":":filled","msg":"Toto pole je povinné."}]');
            });
        } else {
            items.removeClass('required');
            items.each(function itemsEachNotVisible() {
                $(this).children('label').children('span').remove();
            });

            items.find('input, textarea, select').each(function fieldsEach() {
                $(this).prop('required', false);
                $(this).attr('data-nette-rules', '');
            });
        }
    }

    function toggleValue(selector, value)
    {
        let items = $(selector).closest('.form-group');

        items.find('input').each(function itemsFindEachToggle() {
            switch (this.type) {
            case 'text':
            case 'email':
            case 'number':
            case 'password':
                $(this).val(value);
                break;
            case 'radio':
                if ($(this).val() === value) {
                    $(this).iCheck('check');
                } else {
                    $(this).iCheck('uncheck');
                }
                break;
            case 'checkbox':
                if (value === true || value === 1) {
                    $(this).iCheck('check');
                } else {
                    $(this).iCheck('uncheck');
                }
                break;
            default:
                //                            console.debug(this);
                break;
            }
        });
        items.find('textarea').each(function textareaToggleEach() {
            $(this).val(value);
        });
        items.find('select').each(function selectToggleEach() {
            $(this).val(value);
            $(this).trigger('change');
        });
    }
    /**
     * Setup handlers.
     */
    Nette.initForm = function initForm(form) {
        Nette.toggleForm(form);

        if (form.noValidate) {
            return;
        }

        form.noValidate = true;

        // window.LiveForm: addition
        window.LiveForm.forms[form.id] = {
            hasError: false,
            onLoadValidation: false,
        };

        form.addEventListener('submit', function addEventSubmit(e) {
            if (!Nette.validateForm(form) || $(form).hasClass('nais-doublesubmit-protection')) {
                e.stopPropagation();
                e.preventDefault();
            } else {
                $(form).addClass('nais-doublesubmit-protection');
                let $submits = $(form).find(':submit');
                $submits.addClass("disabled");
                setTimeout(function () {
                    $(form).removeClass('nais-doublesubmit-protection');
                    $submits.removeClass('disabled');
                }, 3000);
            }
        });

        $('input').on('ifChecked', () => {
            Nette.toggleForm(form);
        });
        $('input').on('ifUnchecked', () => {
            Nette.toggleForm(form);
        });
        $('select').on('select2:select', () => {
            Nette.toggleForm(form);
        });
        $('.timepicker,.datepicker,.datetimepicker').on('change', () => {
            Nette.toggleForm(form);
        });
        // window.LiveForm: addition
        for (let i = 0; i < form.elements.length; i++) {
            window.LiveForm.setupHandlers(form.elements[i]);
            window.LiveForm.processServerErrors(form.elements[i]);
        }
    };

    /**
     * @private
     */
    Nette.initOnLoad = function initOnLoad() {
        Nette.onDocumentReady(() => {
            for (let i = 0; i < document.forms.length; i++) {
                let form = document.forms[i];
                for (let j = 0; j < form.elements.length; j++) {
                    if (form.elements[j].getAttribute('data-nette-rules')) {
                        Nette.initForm(form);

                        // LiveForm: addition
                        if (window.LiveForm.hasClass(form, 'validate-on-load')) {
                            // This is not so nice way, but I don't want to spoil validateForm, validateControl and other methods with another parameter
                            window.LiveForm.setFormProperty(form, 'onLoadValidation', true);
                            Nette.validateForm(form);
                            window.LiveForm.setFormProperty(form, 'onLoadValidation', false);
                        }

                        break;
                    }
                }
            }

            document.body.addEventListener('click', (e) => {
                let target = e.target;
                while (target) {
                    if (target.form && target.type in {submit: 1, image: 1}) {
                        target.form['nette-submittedBy'] = target;
                        break;
                    }
                    target = target.parentNode;
                }
            });
        });
    };

    /**
     * Converts string to web safe characters [a-z0-9-] text.
     */
    Nette.webalize = function webalize(s) {
        s = s.toLowerCase();
        let res = '';
        let i;
        let ch;
        for (i = 0; i < s.length; i++) {
            ch = Nette.webalizeTable[s.charAt(i)];
            res += ch ? ch : s.charAt(i);
        }
        return res.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    };

    Nette.webalizeTable = {
        // eslint-disable-next-line max-len
        \u00e1: 'a', \u00e4: 'a', \u010d: 'c', \u010f: 'd', \u00e9: 'e', \u011b: 'e', \u00ed: 'i', \u013e: 'l', \u0148: 'n', \u00f3: 'o', \u00f4: 'o', \u0159: 'r', \u0161: 's', \u0165: 't', \u00fa: 'u', \u016f: 'u', \u00fd: 'y', \u017e: 'z',
    };

    return Nette;
}));

(function init($) {

}(jQuery));
